
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import CalendarEventOfferSelectionList from './CalendarEventOfferSelectionList.vue'
import Dialog from 'primevue/dialog'
import { CalendarEventOfferItem } from '@bd/components'

export default defineComponent({
  components: {
    Dialog,
    CalendarEventOfferSelectionList,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:visible', 'selectOffer', 'searchOffer'],
  setup(_, { emit }) {
    const { t } = useI18n()

    const onOfferSelected = (selectedOffer: CalendarEventOfferItem) => {
      emit('selectOffer', selectedOffer)
      emit('update:visible', false)
    }

    return {
      t,
      onOfferSelected,
    }
  },
})
